// import Flatpickr from "react-flatpickr";
import "flatpickr/dist/flatpickr.css";
import moment from "moment";
import InputField from "../../../component/input-field";

const PerformanceDateTime = ({ allowupdate, performdate }) => {
  return (
    <div className="mt-2">
      <InputField
        type="text"
        value={moment(performdate).format("YYYY-MM-DD HH:mm")}
        disabled
      />
    </div>
  );
};

export default PerformanceDateTime;
